// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectPopup_popupOverlay__QqcY4 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color:rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  padding: 1rem;
}

.ProjectPopup_popupContent__D8tRe {
  background: var(--bg-color);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  color: var(--text-color, #333);
  border: 2px solid var(--frame-color);
}

.ProjectPopup_closeButton__wWSsV {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 2.5rem;
  font-weight: bold;
  cursor: pointer;
  color: var(--text-color, #333);
  line-height: 1;
}
.ProjectPopup_closeButton__wWSsV:hover {
    color: var(--hover-color);
}

.ProjectPopup_popupContent__D8tRe h2 {
  font-size: 4rem;
  text-align: center;
  margin-top: 0;
  margin-bottom: 1rem;
  font-family: "Quantify", sans-serif;
  color: var(--title-color, #000);
}

.ProjectPopup_projectDescription__bT86I {
  font-size: 1.3rem;
  font-family: "Astonpoliz", sans-serif;
  line-height: 1.6;
  text-align: justify;
}

.ProjectPopup_imageContainer__Oo1sx {
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.ProjectPopup_projectImage__lWkYF {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  border: 3px solid var(--frame-color, #ccc);
}

.ProjectPopup_popupContent__D8tRe p {
  font-family: "Astonpoliz", sans-serif;
  line-height: 1.6;
  text-align: justify;
}

.ProjectPopup_projectLinks__ngI4z {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.ProjectPopup_link__Y0bdA {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: var(--title-color, #007bff);
  color: var(--bg-color, #fff);
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: -3px 3px 5px 0px var(--shadow-color, #aaa);
}

.ProjectPopup_link__Y0bdA:hover {
  background-color: var(--hover-color, #0056b3);
  transform: translateY(-2px);
}
/* ---------------------- For mobile ---------------------------- */
@media (max-width: 768px) {
  .ProjectPopup_popupOverlay__QqcY4 {
    padding: 1rem;
  }

  .ProjectPopup_popupContent__D8tRe {
    width: 90%;
    padding: 1.5rem;
    max-height: 80vh;
  }

  .ProjectPopup_popupContent__D8tRe h2 {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
  }

  .ProjectPopup_projectDescription__bT86I {
    font-size: 1.1rem;
    line-height: 1.4;
  }

  .ProjectPopup_closeButton__wWSsV {
    font-size: 2rem;
    top: 10px;
    right: 10px;
  }

  .ProjectPopup_projectLinks__ngI4z {
    flex-direction: column;
    gap: 0.5rem;
  }

  .ProjectPopup_link__Y0bdA {
    padding: 0.6rem 1.2rem;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectPopup.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA,mEAAmE;AACnE;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color:rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n  padding: 1rem;\n}\n\n.popupContent {\n  background: var(--bg-color);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  color: var(--text-color, #333);\n  border: 2px solid var(--frame-color);\n}\n\n.closeButton {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 2.5rem;\n  font-weight: bold;\n  cursor: pointer;\n  color: var(--text-color, #333);\n  line-height: 1;\n}\n.closeButton:hover {\n    color: var(--hover-color);\n}\n\n.popupContent h2 {\n  font-size: 4rem;\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-family: \"Quantify\", sans-serif;\n  color: var(--title-color, #000);\n}\n\n.projectDescription {\n  font-size: 1.3rem;\n  font-family: \"Astonpoliz\", sans-serif;\n  line-height: 1.6;\n  text-align: justify;\n}\n\n.imageContainer {\n  width: 100%;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: center;\n}\n\n.projectImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  border: 3px solid var(--frame-color, #ccc);\n}\n\n.popupContent p {\n  font-family: \"Astonpoliz\", sans-serif;\n  line-height: 1.6;\n  text-align: justify;\n}\n\n.projectLinks {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.link {\n  display: inline-block;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--title-color, #007bff);\n  color: var(--bg-color, #fff);\n  text-decoration: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  box-shadow: -3px 3px 5px 0px var(--shadow-color, #aaa);\n}\n\n.link:hover {\n  background-color: var(--hover-color, #0056b3);\n  transform: translateY(-2px);\n}\n/* ---------------------- For mobile ---------------------------- */\n@media (max-width: 768px) {\n  .popupOverlay {\n    padding: 1rem;\n  }\n\n  .popupContent {\n    width: 90%;\n    padding: 1.5rem;\n    max-height: 80vh;\n  }\n\n  .popupContent h2 {\n    font-size: 2.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .projectDescription {\n    font-size: 1.1rem;\n    line-height: 1.4;\n  }\n\n  .closeButton {\n    font-size: 2rem;\n    top: 10px;\n    right: 10px;\n  }\n\n  .projectLinks {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .link {\n    padding: 0.6rem 1.2rem;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupOverlay": `ProjectPopup_popupOverlay__QqcY4`,
	"popupContent": `ProjectPopup_popupContent__D8tRe`,
	"closeButton": `ProjectPopup_closeButton__wWSsV`,
	"projectDescription": `ProjectPopup_projectDescription__bT86I`,
	"imageContainer": `ProjectPopup_imageContainer__Oo1sx`,
	"projectImage": `ProjectPopup_projectImage__lWkYF`,
	"projectLinks": `ProjectPopup_projectLinks__ngI4z`,
	"link": `ProjectPopup_link__Y0bdA`
};
export default ___CSS_LOADER_EXPORT___;
